import React, { useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroup,
  InputGroupText,
  Container,
  Row,
  Col,
} from "reactstrap";
import PageLayout from "./PageLayout";
import { useForm, Controller } from "react-hook-form";
import { Link } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "src/state/store/store";
import { useNavigate } from "react-router-dom";
import { userRegisterAction } from "src/state/slices/authSlice";
import { setOffcanvasOpen } from "src/state/slices/asideslice";

function SignUpPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    register,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [terms, setTerms] = useState(false);

  const handleTogglePassword = () => setShowPassword(!showPassword);
  const handleToggleConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);
  const onSubmit = async (data) => {
    console.log("Form Data: ", data);
    setLoading(true);
    setError("");

    try {
      const res = await dispatch(
        userRegisterAction({
          name: data.name,
          email: data.email,
          password: data.password,
          contact: data.contact,
          type: data.type,
        })
      ).unwrap();
      if (res.status === 200) {
        navigate("/");
        dispatch(setOffcanvasOpen(true));
      }
    } catch (e) {
      setError(e.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageLayout>
      <main>
        <section
          className="section section-shaped section-lg"
          style={{
            backgroundColor: "#f8f9fa",
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg="6">
                <Card
                  className="shadow border-0"
                  style={{ borderRadius: "15px", backgroundColor: "white" }}
                >
                  <CardHeader
                    className="text-white text-center"
                    style={{
                      backgroundColor: "#5e72e4",
                      borderRadius: "15px 15px 0 0",
                      padding: "1.5rem",
                    }}
                  >
                    <h4 style={{ fontWeight: "600", margin: 0 }}>
                      Create an Account
                    </h4>
                    <p style={{ fontSize: "0.9rem", margin: "0.5rem 0 0" }}>
                      Sign up to join the Journal platform
                    </p>
                  </CardHeader>
                  <CardBody className="px-lg-5 py-lg-5">
                    <Form role="form" onSubmit={handleSubmit(onSubmit)}>
                      {/* Name Field */}
                      <FormGroup className="mb-4">
                        <InputGroup className="input-group-alternative">
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                          >
                            <i className="ni ni-single-02 text-primary" />
                          </InputGroupText>
                          <Controller
                            name="name"
                            control={control}
                            rules={{ required: "Full Name is required" }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                placeholder="Full Name"
                                type="text"
                              />
                            )}
                          />
                        </InputGroup>
                        {errors.name &&
                          typeof errors.name.message === "string" && (
                            <div className="error-text">
                              {errors.name.message}
                            </div>
                          )}
                      </FormGroup>

                      {/* Email Field */}
                      <FormGroup className="mb-4">
                        <InputGroup className="input-group-alternative">
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                          >
                            <i className="ni ni-email-83 text-primary" />
                          </InputGroupText>
                          <Controller
                            name="email"
                            control={control}
                            rules={{
                              required: "Email is required",
                              pattern: {
                                value:
                                  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                                message: "Invalid email address",
                              },
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                placeholder="Email Address"
                                type="email"
                              />
                            )}
                          />
                        </InputGroup>
                        {errors.email &&
                          typeof errors.email.message === "string" && (
                            <div className="error-text">
                              {errors.email.message}
                            </div>
                          )}
                      </FormGroup>

                      {/* Contact Field */}
                      <FormGroup className="mb-4">
                        <InputGroup className="input-group-alternative">
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                          >
                            <i className="ni ni-mobile-button text-primary" />
                          </InputGroupText>
                          <Controller
                            name="contact"
                            control={control}
                            rules={{
                              required: "Mobile Number is required",
                              pattern: {
                                value: /^[0-9]{10}$/,
                                message: "Invalid mobile number",
                              },
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                placeholder="Mobile Number"
                                type="tel"
                              />
                            )}
                          />
                        </InputGroup>
                        {errors.contact &&
                          typeof errors.contact.message === "string" && (
                            <div className="error-text">
                              {errors.contact.message}
                            </div>
                          )}
                      </FormGroup>

                      {/* Password Field */}
                      <FormGroup className="mb-4">
                        <InputGroup className="input-group-alternative">
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                          >
                            <i className="ni ni-lock-circle-open text-primary" />
                          </InputGroupText>
                          <Controller
                            name="password"
                            control={control}
                            rules={{
                              required: "Password is required",
                              minLength: {
                                value: 6,
                                message:
                                  "Password must be at least 6 characters",
                              },
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                placeholder="Password"
                                type={showPassword ? "text" : "password"}
                              />
                            )}
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={handleTogglePassword}
                          >
                            <i
                              className={`fas ${
                                showPassword ? "fa-eye-slash" : "fa-eye"
                              }`}
                            />
                          </InputGroupText>
                        </InputGroup>
                        {errors.password &&
                          typeof errors.password.message === "string" && (
                            <div className="error-text">
                              {errors.password.message}
                            </div>
                          )}
                      </FormGroup>

                      {/* Confirm Password Field */}
                      <FormGroup className="mb-4">
                        <InputGroup className="input-group-alternative">
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                            }}
                          >
                            <i className="ni ni-lock-circle-open text-primary" />
                          </InputGroupText>
                          <Controller
                            name="confirmPassword"
                            control={control}
                            rules={{
                              required: "Confirm Password is required",
                              validate: (value) =>
                                value === getValues("password") ||
                                "Passwords do not match",
                            }}
                            render={({ field }) => (
                              <Input
                                {...field}
                                placeholder="Confirm Password"
                                type={showConfirmPassword ? "text" : "password"}
                              />
                            )}
                          />
                          <InputGroupText
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                              cursor: "pointer",
                            }}
                            onClick={handleToggleConfirmPassword}
                          >
                            <i
                              className={`fas ${
                                showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                              }`}
                            />
                          </InputGroupText>
                        </InputGroup>
                        {errors.confirmPassword &&
                          typeof errors.confirmPassword.message ===
                            "string" && (
                            <div className="error-text">
                              {errors.confirmPassword.message}
                            </div>
                          )}
                      </FormGroup>

                      {/* Account Type Field */}
                      <div className="mb-3">
                        <small className="text-uppercase font-weight-bold">
                          {" "}
                          Who you are
                        </small>
                      </div>
                      <div className="d-flex flex-wrap mb-3">
                        <div className="custom-control custom-radio mr-3">
                          <input
                            className="custom-control-input"
                            id="customRadio1"
                            name="type"
                            type="radio"
                            value="publisher"
                            {...register("type", {
                              required: "Account type is required",
                            })}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customRadio1"
                          >
                            Publisher
                          </label>
                        </div>
                        <div className="custom-control custom-radio mr-3">
                          <input
                            className="custom-control-input"
                            id="customRadio2"
                            name="type"
                            type="radio"
                            value="reviewer"
                            {...register("type")}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customRadio2"
                          >
                            Reviewer
                          </label>
                        </div>
                        <div className="custom-control custom-radio">
                          <input
                            className="custom-control-input"
                            id="customRadio3"
                            name="type"
                            type="radio"
                            value="author"
                            {...register("type")}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customRadio3"
                          >
                            Author
                          </label>
                        </div>
                      </div>

                      {errors.type &&
                        typeof errors.type.message === "string" && (
                          <div className="error-text">
                            {errors.type.message}
                          </div>
                        )}
                      <div className="mb-4 d-flex  align-items-center">
                        <input
                          type="checkbox"
                          onClick={() => setTerms(!terms)}
                        />
                        <small className="text-uppercase font-weight-bold">
                          <Link
                            to="/terms-condition"
                            style={{
                              marginLeft: "5px",
                              color: "#5e72e4",
                              fontWeight: "bold",
                              textDecoration: "underline",
                              textTransform: "capitalize",
                            }}
                          >
                            terms and conditions
                          </Link>
                        </small>
                      </div>
                      <FormGroup check className="text-center">
                        <Button
                          className="btn-lg"
                          color="primary"
                          type="submit"
                          style={{
                            backgroundColor: "#5e72e4",
                            borderColor: "transparent",
                            borderRadius: "50px",
                            padding: "0.8rem 2rem",
                          }}
                          disabled={loading || !terms}
                        >
                          {loading ? "Processing..." : "Sign Up"}
                        </Button>
                      </FormGroup>
                      {error && (
                        <div className="error-text text-center">{error}</div>
                      )}
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
    </PageLayout>
  );
}

export default SignUpPage;
